var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "base-setup",
      on: {
        click: function ($event) {
          _vm.showIconSelect = false
        },
      },
    },
    [
      _vm.isProcess
        ? _c(
            "el-form",
            {
              ref: "baseSetting",
              attrs: {
                model: _vm.setup,
                "label-position": "right",
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "审批流名称",
                    rules: _vm.getRule("请输入审批单名称"),
                    prop: "templateName",
                    error: _vm.templateNameError,
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: "",
                      size: "medium",
                      maxlength: "24",
                      placeholder: "请输入审批单名称",
                      "show-word-limit": "",
                    },
                    on: {
                      input: function ($event) {
                        return _vm.setForm($event, "templateName")
                      },
                    },
                    model: {
                      value: _vm.setup.templateName,
                      callback: function ($$v) {
                        _vm.$set(_vm.setup, "templateName", $$v)
                      },
                      expression: "setup.templateName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "审批说明" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入审批说明",
                      type: "textarea",
                      "show-word-limit": "",
                      autosize: { minRows: 3, maxRows: 5 },
                      maxlength: "64",
                    },
                    on: {
                      input: function ($event) {
                        return _vm.setForm($event, "remark")
                      },
                    },
                    model: {
                      value: _vm.setup.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.setup, "remark", $$v)
                      },
                      expression: "setup.remark",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "指定功能" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        disabled: "",
                        placeholder: "请选择",
                        size: "medium",
                      },
                      model: {
                        value: _vm.functionType,
                        callback: function ($$v) {
                          _vm.functionType = $$v
                        },
                        expression: "functionType",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: _vm.setup.function, value: "转移" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "el-form",
            {
              ref: "baseSetting",
              attrs: {
                model: _vm.setup,
                "label-position": "right",
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "审批单名称",
                    rules: _vm.getRule("请输入审批单名称"),
                    prop: "templateName",
                    error: _vm.templateNameError,
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      size: "medium",
                      maxlength: "24",
                      placeholder: "请输入审批单名称",
                      "show-word-limit": "",
                    },
                    on: {
                      input: function ($event) {
                        return _vm.setForm($event, "templateName")
                      },
                    },
                    model: {
                      value: _vm.setup.templateName,
                      callback: function ($$v) {
                        _vm.$set(_vm.setup, "templateName", $$v)
                      },
                      expression: "setup.templateName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "审批说明" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入审批说明",
                      type: "textarea",
                      "show-word-limit": "",
                      autosize: { minRows: 3, maxRows: 5 },
                      maxlength: "64",
                    },
                    on: {
                      input: function ($event) {
                        return _vm.setForm($event, "remark")
                      },
                    },
                    model: {
                      value: _vm.setup.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.setup, "remark", $$v)
                      },
                      expression: "setup.remark",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "group",
                  attrs: {
                    label: "审批类目",
                    rules: _vm.getRule("请选择审批类目"),
                    prop: "groupId",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择审批类目", size: "medium" },
                      on: {
                        input: function ($event) {
                          return _vm.setForm($event, "groupId")
                        },
                      },
                      model: {
                        value: _vm.setup.groupId,
                        callback: function ($$v) {
                          _vm.$set(_vm.setup, "groupId", $$v)
                        },
                        expression: "setup.groupId",
                      },
                    },
                    _vm._l(_vm.fromGroup, function (op, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: op.name, value: op.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "发起人范围",
                    rules: _vm.getRule("请选择发起人范围"),
                    prop: "whoCommit",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "select-u",
                      attrs: {
                        "value-key": "name",
                        placeholder: "请选择可以发起此表单的人员",
                        size: "medium",
                        multiple: "",
                        "popper-class": "hidden",
                      },
                      on: { "remove-tag": _vm.removeTag },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.selectUser.apply(null, arguments)
                        },
                      },
                      model: {
                        value: _vm.setup.whoCommit,
                        callback: function ($$v) {
                          _vm.$set(_vm.setup, "whoCommit", $$v)
                        },
                        expression: "setup.whoCommit",
                      },
                    },
                    _vm._l(_vm.setup.whoCommit, function (wc, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: wc.name, value: wc },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
      _c("org-picker", {
        ref: "orgPicker",
        attrs: { title: "发起人范围", multiple: "" },
        on: { ok: _vm.selected },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }